import { createContext, useEffect, useState } from "react";

const initalValues = false;

export const AuthUserContext = createContext(initalValues);

const AuthUserContextProvider = ({ children }) => {
  const [isAuth, setIsAuth] = useState(initalValues);

  useEffect(() => {
    const userData = localStorage.getItem("uinf");

    if (userData) {
      let status = JSON.parse(userData).status.id;
      if (status == 2) {
        setIsAuth(false);
      } else {
        setIsAuth(true);
      }
    }
  }, [localStorage]);

  return (
    <AuthUserContext.Provider value={{ isAuth, setIsAuth }}>
      {children}
    </AuthUserContext.Provider>
  );
};

export default AuthUserContextProvider;
